module.exports = __webpack_public_path__ + "img/banner-1.cb71040b.png";